module.exports = __webpack_public_path__ + "img/tele.36a8e7d7.png";